module.exports = __webpack_public_path__ + "img/drop.b49836cb.svg";